// CHANGES TO THIS FILE MAY CAUSE INCORRECT BEHAVIOR AND WILL BE LOST IF THE CODE IS REGENERATED
// auto-generated on 3/14/2024 6:02:19 AM by John Caccavaro's (caccavaro123@gmail.com) Frameworks tool.

/* eslint-disable @typescript-eslint/no-empty-interface */

import { SecurityRoleTypeEnum } from '../../../appCore/models/schema/Schema';

export enum GetInitialStateEnum {}

export enum OnboardingStepTypeEnum {
  inviteClient = 0,
  createAdmin = 1,
  setupBankAccount = 2,
}

export enum GetDuePayrollListEnum {}

export enum GetFirstPayrollToRunListEnum {}

export enum GetPayrollCalendarEnum {}

export enum GetReportsListEnum {}

export enum PayrollCalendarEventTypeEnum {
  notDefined = 0,
  bankingHoliday = 1,
  processingDate = 2,
  payDate = 3,
  invoiceDueDate = 4,
  other = 5,
  yearEndFormDue = 6,
}

export enum NudgeSubmittedForApprovalPayrollEnum {}

export enum GetCalendarEventEnum {}

export enum PayrollActionTypeEnum {
  notDefined = 0,
  run = 1,
  view = 2,
  nudge = 3,
  resume = 4,
}

export enum PayrollStatusTypeEnum {
  notDefined = 0,
  notStarted = 1,
  submittedForApproval = 2,
  approved = 3,
  inProcess = 4,
  pastDue = 5,
}

export enum PayrollSummarySortByEnum {
  notDefined = 0,
  paydate = 1,
  payPeriod = 2,
  autoRun = 3,
  status = 4,
  twoStepApproval = 5,
}

export enum ExportPayrollCalendarEnum {}

export enum ReportsSortByEnum {
  notDefined = 0,
  client = 1,
  paygroup = 2,
  paydate = 3,
  payPeriod = 4,
}

export enum SetupPayrollFirmEnum {}

export enum MaintainTwoStepApprovalEnum {
  invalidPartnerCompanyId = 0,
}

export interface GetInitialStateRequestInterface {
  includeCompanyList: boolean;
  includePayGroupList: boolean;
  partnerId: number;
}

export interface GetInitialStateResponseInterface {
  onboardingStepList: Array<OnboardingStepInterface>;
  payGroupList: Array<PayGroupInterface>;
  clientSummaryList: Array<ClientSummaryInterface>;
  validationResults: ValidationResultsInterface;
}

export interface OnboardingStepInterface {
  stepType: OnboardingStepTypeEnum;
  isApplicable: boolean;
}

export interface ClientSummaryInterface {
  id: number;
  legalName: string;
  nextPayDate: string;
  twoStepApproval: boolean;
  isOnboardingCompleted: boolean;
  securityRoleType: SecurityRoleTypeEnum;
}

export interface GetDuePayrollListRequestInterface {
  filterByClientIdList: boolean;
  clientIdList: Array<number>;
  filterByPayGroupIdList: boolean;
  payGroupIdList: Array<number>;
  sortByEnum: PayrollSummarySortByEnum;
  isDescending: boolean;
  partnerId: number;
}

export interface GetDuePayrollListResponseInterface {
  payrollSummaryList: Array<PayrollSummaryInterface>;
  validationResults: ValidationResultsInterface;
}

export interface GetFirstPayrollToRunListRequestInterface {
  filterByClientIdList: boolean;
  clientIdList: Array<number>;
  filterByPayGroupIdList: boolean;
  payGroupIdList: Array<number>;
  sortByEnum: PayrollSummarySortByEnum;
  isDescending: boolean;
  partnerId: number;
}

export interface GetFirstPayrollToRunListResponseInterface {
  payrollSummaryList: Array<PayrollSummaryInterface>;
  validationResults: ValidationResultsInterface;
}

export interface GetPayrollCalendarRequestInterface {
  filterByClientIdList: boolean;
  payGroupIdList: Array<number>;
  filterByPayGroupIdList: boolean;
  clientIdList: Array<number>;
  filterByEventTypeList: boolean;
  eventTypeList: Array<number>;
  startDate: string;
  endDate: string;
  isExport: boolean;
  partnerId: number;
  filterByAdminList: boolean;
  adminIdList: Array<number>;
}

export interface GetPayrollCalendarResponseInterface {
  content: string; // IMPORTANT. Modified by Ruben Terzian due to inability to unify response type between backend and frontend
  fileName: string;
  mimeType: string;
  payrollCalendarEventList: Array<PayrollCalendarEventSummaryInterface>;
  validationResults: ValidationResultsInterface;
}

export interface GetReportsListRequestInterface {
  sortByEnum: ReportsSortByEnum;
  isDescending: boolean;
  clientIdList: Array<number>;
  filterByClientIdList: boolean;
  filterViewedReports: boolean;
  partnerId: number;
}

export interface GetReportsListResponseInterface {
  reportSummaryList: Array<ReportSummaryInterface>;
  validationResults: ValidationResultsInterface;
}

export interface PayrollSummaryInterface {
  id: number;
  clientName: string;
  payGroupName: string;
  payGroupId: number;
  payDate: string;
  payPeriodStartDate: string;
  payPeriodEndDate: string;
  autoRun: boolean;
  twoStepApproval: boolean;
  status: PayrollStatusTypeEnum;
  action: PayrollActionTypeEnum;
  calendarId: number;
  payPeriodId?: number;
  companyId: number;
  calendarEventId: number;
  periodStartDate: string;
  processingDate: string;
  isDueToday: boolean;
  approvalDate?: string;
  hasOnboardedEmployee: boolean;
  accountOwnerAcceptedTos: boolean;
}

export interface ReportSummaryInterface {
  id: number;
  clientName: string;
  payGroupName: string;
  payGroupId: number;
  payDate: string;
  payPeriodStartDate: string;
  payPeriodEndDate: string;
  companyId: number;
}

export interface NudgeSubmittedForApprovalPayrollRequestInterface {
  payPeriodId: number;
  companyId: number;
  payGroupId: number;
  partnerId: number;
}

export interface NudgeSubmittedForApprovalPayrollResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface GetCalendarEventRequestInterface {
  calendarEventId: number;
  partnerId: number;
}

export interface GetCalendarEventResponseInterface {
  payrollCalendarEvent: PayrollCalendarEventInterface;
  holidayEvent: HolidayEventInterface;
  invoiceEvent: InvoiceEventInterface;
  otherEvent: OtherEventInterface;
  validationResults: ValidationResultsInterface;
}

export interface PayrollCalendarEventSummaryInterface {
  id: number;
  clientName: string;
  companyId: number;
  payrollCalendarEventType: PayrollCalendarEventTypeEnum;
  eventDate: string;
  eventName: string;
  isActualPayDate: boolean;
  payGroupName: string;
  payPeriod: string;
  processingDate?: string;
  payDate?: string;
  invoiceId?: number;
}

export interface EventInterface {
  id: number;
  companyId: number;
  clientName: string;
  payrollCalendarEventType: PayrollCalendarEventTypeEnum;
  eventName: string;
}

export interface PayrollCalendarEventInterface extends EventInterface {
  payGroupId: number;
  payGroupName: string;
  processingDate?: string;
  payDate?: string;
  administratorList: Array<string>;
  isActualPayDate: boolean;
}

export interface HolidayEventInterface extends EventInterface {
  date: string;
}

export interface InvoiceEventInterface extends EventInterface {
  dueDate: string;
  invoiceId: number;
  invoiceDate: string;
}

export interface OtherEventInterface extends EventInterface {
  dueDate: string;
}

export interface PayGroupInterface {
  id: number;
  name: string;
  number: number;
  nextPayDate?: string;
}

export interface ExportPayrollCalendarRequestInterface {
  startDate: string;
  endDate: string;
  partnerId: number;
}

export interface ExportPayrollCalendarResponseInterface {
  content: Array<number>;
  fileName: string;
  mimeType: string;
  validationResults: ValidationResultsInterface;
}

export interface PersistReportRequestInterface {
  id: number;
  markViewed: boolean;
  companyId: number;
  partnerId: number;
}

export interface PersistReportResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface GetPayGroupListRequestInterface {
  partnerId: number;
}

export interface GetPayGroupListResponseInterface {
  payGroupList: Array<PayGroupInterface>;
  validationResults: ValidationResultsInterface;
}

export interface GetPartnerStatusRequestInterface {
  partnerId: number;
  includePartnerCompany: boolean;
}

export interface GetPartnerStatusResponseInterface {
  runsPayroll: boolean;
  paysFees: boolean;
  validationResults: ValidationResultsInterface;
}

export interface SetUpPayrollFirmRequestInterface {
  partnerId: number;
}

export interface SetUpPayrollFirmResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface MaintainTwoStepApprovalRequestInterface {
  partnerCompanyId: number;
  clientCompanyIdList: Array<number>;
  enableForAllClients: boolean;
  turnOn: boolean;
}

export interface MaintainTwoStepApprovalResponseInterface {
  validationResults: ValidationResultsInterface;
}

export enum ValidationSeverityEnum {
  NotDefined = 0,
  Passed,
  Information,
  Warning,
  Error,
}

export interface ValidationResultInterface {
  validationSeverityEnum: ValidationSeverityEnum;
  validationMessage: string;
  exceptionInformation: string;
  validationCode: number;
  validationTag: string;
  isValid: boolean;
}

export interface ValidationResultsInterface {
  validationResultList?: Array<ValidationResultInterface>;
}

import { Post } from '../../../httpClient';

export class PartnerAccessService {
  getInitialState(request: GetInitialStateRequestInterface): Promise<GetInitialStateResponseInterface> {
    return Post('/PayrollPartnerAccess/getInitialState', request);
  }

  getDuePayrollList(request: GetDuePayrollListRequestInterface): Promise<GetDuePayrollListResponseInterface> {
    return Post('/PayrollPartnerAccess/getDuePayrollList', request);
  }

  getFirstPayrollToRunList(
    request: GetFirstPayrollToRunListRequestInterface
  ): Promise<GetFirstPayrollToRunListResponseInterface> {
    return Post('/PayrollPartnerAccess/getFirstPayrollToRunList', request);
  }

  getPayrollCalendar(request: GetPayrollCalendarRequestInterface): Promise<GetPayrollCalendarResponseInterface> {
    return Post('/PayrollPartnerAccess/getPayrollCalendar', request);
  }

  getReportsList(request: GetReportsListRequestInterface): Promise<GetReportsListResponseInterface> {
    return Post('/PayrollPartnerAccess/getReportsList', request);
  }

  nudgeSubmittedForApprovalPayroll(
    request: NudgeSubmittedForApprovalPayrollRequestInterface
  ): Promise<NudgeSubmittedForApprovalPayrollResponseInterface> {
    return Post('/PayrollPartnerAccess/nudgeSubmittedForApprovalPayroll', request);
  }

  getCalendarEvent(request: GetCalendarEventRequestInterface): Promise<GetCalendarEventResponseInterface> {
    return Post('/PayrollPartnerAccess/getCalendarEvent', request);
  }

  exportPayrollCalendar(
    request: ExportPayrollCalendarRequestInterface
  ): Promise<ExportPayrollCalendarResponseInterface> {
    return Post('/PayrollPartnerAccess/exportPayrollCalendar', request);
  }

  persistReport(request: PersistReportRequestInterface): Promise<PersistReportResponseInterface> {
    return Post('/PayrollPartnerAccess/persistReport', request);
  }

  getPayGroupList(request: GetPayGroupListRequestInterface): Promise<GetPayGroupListResponseInterface> {
    return Post('/PayrollPartnerAccess/getPayGroupList', request);
  }

  getPartnerStatus(request: GetPartnerStatusRequestInterface): Promise<GetPartnerStatusResponseInterface> {
    return Post('/PayrollPartnerAccess/getPartnerStatus', request);
  }

  setUpPayrollFirm(request: SetUpPayrollFirmRequestInterface): Promise<SetUpPayrollFirmResponseInterface> {
    return Post('/PayrollPartnerAccess/setUpPayrollFirm', request);
  }

  maintainTwoStepApproval(
    request: MaintainTwoStepApprovalRequestInterface
  ): Promise<MaintainTwoStepApprovalResponseInterface> {
    return Post('/PayrollPartnerAccess/maintainTwoStepApproval', request);
  }
}

export default new PartnerAccessService();
